"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRegister = class UcRegister extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const [editor] = args;
        if (editor.isNew) {
            console.log(editor.getChanges({ skipEmbeddedLists: true }));
            return editor.getChanges({ skipEmbeddedLists: true });
        }
        return {
            id: editor.id,
            etag: editor.getETAG(),
            ...editor.getChanges({ skipEmbeddedLists: true })
        };
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    messages;
    formName;
    labelAlign;
    async $$load_labelAlign() {
        return this.$config.forms.defaultLabelAlign;
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_register', { asResource: true, parameters: { id: this.oid } })
            : this.$fn.schemaDefaults('CreateRegister');
    }
    editor;
    async $$load_editor() {
        return this.item.editor();
    }
    ux;
    b_6126985650642047_dataSource;
    dataMembers = ['messages', 'formName', 'labelAlign', 'formId', 'item', 'editor', 'ux', 'b_6126985650642047_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    submitNewItem: this.$fn.pgettext("Register|Command", "Create register"),
                    saveItem: this.$fn.pgettext("Register|Command", "Save changes"),
                },
                formName: "register",
                labelAlign: null,
                formId: null,
                item: null,
                editor: null,
                ux: null,
                b_6126985650642047_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "own",
                    },
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_emit_8202_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async act_8564662037462133_crud_8200_getActionArgs($event) {
        return {
            objectType: "register",
            op: "upsert",
            data: this.getPayload(this.editor),
        };
    }
    async evh_8564662037462133_submit(event, scope) {
        return await this.actions.evh_8564662037462133_submit.executeFromDOM(this, event, scope);
    }
    async act_655921014111650_emit_8206_getActionArgs($event) {
        return {
            event: "deleted",
            value: this.editor,
        };
    }
    async act_655921014111650_crud_8204_getActionArgs($event) {
        return {
            objectType: "register",
            op: "delete",
            data: this.getPayload(this.editor),
        };
    }
    async act_655921014111650_crud_8204_getConfirm($event) {
        return {
            header: this.$fn.pgettext("Register|Header", "Please confirm deleting this register."),
            message: this.$fn.pgettext("Register", "This action cannot be undone."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_655921014111650_clickPreventStop(event, scope) {
        return await this.actions.evh_655921014111650_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1238468668488283_emit_8208_getActionArgs($event) {
        return {
            event: "deleted",
            value: {},
        };
    }
    async evh_1238468668488283_clickPreventStop_8207_getWhen($event) {
        return this.item.isNew;
    }
    async evh_1238468668488283_clickPreventStop(event, scope) {
        return await this.actions.evh_1238468668488283_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1889980785424776_reload(event, scope) {
        return await this.actions.evh_1889980785424776_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8198 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8197 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8198,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8197],
        });
        const act_8564662037462133_emit_8202 = new core_1.actions.EmitAction({
            actionArgs: this.act_8564662037462133_emit_8202_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_success_8201 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_emit_8202,
            event: "success",
            displayName: "emit",
        });
        const act_8564662037462133_crud_8200 = new core_1.actions.CRUDAction({
            actionArgs: this.act_8564662037462133_crud_8200_getActionArgs,
            displayName: "save",
            events: [evh_8564662037462133_success_8201],
        });
        const evh_8564662037462133_submit_8199 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_crud_8200,
            event: "submit",
            displayName: "save",
        });
        const evh_8564662037462133_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_submit_8199],
        });
        const act_655921014111650_emit_8206 = new core_1.actions.EmitAction({
            actionArgs: this.act_655921014111650_emit_8206_getActionArgs,
            events: [],
        });
        const evh_655921014111650_success_8205 = new core_1.actions.EventHandlerImpl({
            action: act_655921014111650_emit_8206,
            event: "success",
            displayName: "emit",
        });
        const act_655921014111650_crud_8204 = new core_1.actions.CRUDAction({
            actionArgs: this.act_655921014111650_crud_8204_getActionArgs,
            confirm: this.act_655921014111650_crud_8204_getConfirm,
            displayName: "delete",
            events: [evh_655921014111650_success_8205],
        });
        const evh_655921014111650_clickPreventStop_8203 = new core_1.actions.EventHandlerImpl({
            action: act_655921014111650_crud_8204,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_655921014111650_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_655921014111650_clickPreventStop_8203],
        });
        const act_1238468668488283_emit_8208 = new core_1.actions.EmitAction({
            actionArgs: this.act_1238468668488283_emit_8208_getActionArgs,
            events: [],
        });
        const evh_1238468668488283_clickPreventStop_8207 = new core_1.actions.EventHandlerImpl({
            action: act_1238468668488283_emit_8208,
            event: "click.prevent.stop",
            when: this.evh_1238468668488283_clickPreventStop_8207_getWhen,
            displayName: "emit",
        });
        const evh_1238468668488283_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1238468668488283_clickPreventStop_8207],
        });
        const act_1889980785424776_reloadComponentData_8210 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_1889980785424776_reload_8209 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_reloadComponentData_8210,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_1889980785424776_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1889980785424776_reload_8209],
        });
        return {
            act_7315092382398562_reloadComponentData_8198,
            evh_7315092382398562_reload_8197,
            evh_7315092382398562_reload,
            act_8564662037462133_emit_8202,
            evh_8564662037462133_success_8201,
            act_8564662037462133_crud_8200,
            evh_8564662037462133_submit_8199,
            evh_8564662037462133_submit,
            act_655921014111650_emit_8206,
            evh_655921014111650_success_8205,
            act_655921014111650_crud_8204,
            evh_655921014111650_clickPreventStop_8203,
            evh_655921014111650_clickPreventStop,
            act_1238468668488283_emit_8208,
            evh_1238468668488283_clickPreventStop_8207,
            evh_1238468668488283_clickPreventStop,
            act_1889980785424776_reloadComponentData_8210,
            evh_1889980785424776_reload_8209,
            evh_1889980785424776_reload,
            save: act_8564662037462133_crud_8200,
            delete: act_655921014111650_crud_8204,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcRegister.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegister.prototype, "onOid", null);
UcRegister = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRegister);
exports.default = UcRegister;
vue_property_decorator_1.Vue.component("UcRegister", UcRegister);
